
import {
    
    loginStart,
    loginSuccess,
    loginFailure,
    clearAlert
    
  } from "./userSlice";
  // import axios from 'axios';
import { addUserToLocalStorage } from "./functions";
import authFetch from "../axios";
export const loginUser = async (currentUser, dispatch) => {
    dispatch(loginStart());
    try {
      const res = await authFetch.post("login", currentUser);
      const responseData = res.data;

      if (responseData?.success) {
        const token = responseData.access_token;
        const user = responseData.user;

        dispatch(
          loginSuccess({
            token,
            user,
            message: responseData.message,
            name: responseData.name,
            tokenType: responseData.token_type,
            expiresAt: responseData.expires_at,
          }),
        );

        addUserToLocalStorage({ user, token });
      }
      else {
        dispatch(loginFailure(responseData?.message || "Invalid credentials"));
        setTimeout(() => dispatch(clearAlert()), 5000);
      }
     
    } catch (error) {
      console.log(error.response);
      const errorMsg = error?.response?.data?.message || "Internal server error";
      dispatch(loginFailure(errorMsg));
      setTimeout(() => dispatch(clearAlert()), 5000);
    }
  };
